/** @format */
import { Heading } from '@mpb-com/feather/components/atoms/heading';
import { HeadingSize } from '@mpb-com/feather/components/atoms/heading/types';
import {
    Skeleton,
    SkeletonVariant,
} from '@mpb-com/feather/components/atoms/skeleton';
import React from 'react';

import { ScrollableCarousel } from '@toucan/client/shared/components/scrollable-carousel';

import { ModelCard } from '@toucan/client/features/search/components/model-card';

import { StyledModelRecommendationsCarousel } from './';
import { DEFAULT_TEST_ID } from './constants';

export const ModelRecommendationsCarouselSkeleton = () => {
    return (
        <StyledModelRecommendationsCarousel
            data-testid={`${DEFAULT_TEST_ID}__skeleton`}
        >
            <Heading
                size={HeadingSize.H2}
                className="recommendations-carousel-heading skeleton-heading"
            >
                <Skeleton variant={SkeletonVariant.TEXT} />
            </Heading>
            <ScrollableCarousel
                className="model-recommendations-carousel"
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
                items={[...Array(4)].map((_, index) => (
                    <ModelCard
                        // eslint-disable-next-line react/no-array-index-key -- Legacy code: do not use as an example.
                        key={`skeleton-card-${index}`}
                        className="model-recommendations-card-link"
                    />
                ))}
                showButtons
            />
        </StyledModelRecommendationsCarousel>
    );
};
